import { render, staticRenderFns } from "./89.vue?vue&type=template&id=23b1831a&scoped=true&"
var script = {}
import style0 from "./89.vue?vue&type=style&index=0&id=23b1831a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1831a",
  null
  
)

export default component.exports